module.exports = __webpack_public_path__ + "static/media/IconoResultadosAprendizaje.ff70c373.svg";